export const STORAGE_KEYS = {
  ADID: 'ADID',
  ADGROUP: 'ADGROUP'
};

export const STATES = [
  'AL',
  'AK',
  'AS',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FM',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MH',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'MP',
  'OH',
  'OK',
  'OR',
  'PW',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VI',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY'
];

export const QUESTIONS = [
  {
    id: '1',
    questionType: 'input',
    question: 'What is your first name?',
    description: [],
    name: 'firstName',
    required: true,
    type: 'text',
    placeholder: 'Type your answer here...',
    options: [],
    next: 'lastName'
  },
  {
    id: '2',
    questionType: 'input',
    question: 'What is your last name?',
    description: [],
    name: 'lastName',
    required: true,
    type: 'text',
    placeholder: 'Type your answer here...',
    options: [],
    next: 'email'
  },
  {
    id: '3',
    questionType: 'input',
    question: 'What is your email address?',
    description: [],
    name: 'email',
    required: true,
    type: 'email',
    placeholder: 'name@example.com',
    options: [],
    next: 'mailingAddress'
  },
  {
    id: '4',
    questionType: 'text',
    question: 'Enter your mailing address',
    description: [
      'This is the address where we will ship the aiSLE MGMT Welcome Kit. You will have the opportunity to confirm the address after entry'
    ],
    name: 'mailingAddress',
    required: '',
    type: '',
    placeholder: '',
    options: [],
    next: 'streetAddress'
  },
  {
    id: 'a',
    questionType: 'input',
    question: 'What is your street address?',
    description: [],
    name: 'streetAddress',
    required: true,
    type: 'text',
    placeholder: 'Type your answer here...',
    options: [],
    next: 'apartmentNumber'
  },
  {
    id: 'b',
    questionType: 'input',
    question: 'What is your apartment or suite number?',
    description: [
      'For example, Apt 1',
      'This question is optional. If you do not need to enter an apartment number, press OK'
    ],
    name: 'apartmentNumber',
    required: false,
    type: 'text',
    placeholder: 'Type your answer here...',
    options: [],
    next: 'city'
  },
  {
    id: 'c',
    questionType: 'input',
    question: 'City?',
    description: [],
    name: 'city',
    required: true,
    type: 'text',
    placeholder: 'Type your answer here...',
    options: [],
    next: 'state'
  },
  {
    id: 'd',
    questionType: 'inputFilter',
    question: 'State?',
    description: [],
    name: 'state',
    required: true,
    type: 'text',
    placeholder: 'Type your answer here...',
    options: STATES,
    next: 'zipCode'
  },
  {
    id: 'e',
    questionType: 'input',
    question: 'Zip code?',
    description: [],
    name: 'zipCode',
    required: true,
    type: 'text',
    placeholder: 'Type your answer here...',
    options: [],
    next: 'confirmAddress'
  },
  {
    id: 'f',
    questionType: 'text',
    question: 'Great! Please confirm your address:',
    description: [],
    name: 'confirmAddress',
    required: false,
    type: '',
    placeholder: '',
    options: [],
    next: 'clinicianName'
  },
  {
    id: '5',
    questionType: 'input',
    question: 'What is the full name of your clinician who you see for lupus?',
    description: [],
    name: 'clinicianName',
    required: true,
    type: 'text',
    placeholder: 'Type your answer here...',
    options: [],
    next: 'clinicianType'
  },
  {
    id: '6',
    questionType: 'multipleChoice',
    question: 'What type of clinician is ...?',
    description: [],
    name: 'clinicianType',
    required: false,
    type: '',
    placeholder: '',
    options: [
      {
        id: 'A',
        text: 'Rheumatologist',
        next: 'clinicianCity'
      },
      {
        id: 'B',
        text: 'Family Practice or General Practitioner',
        next: 'clinicianCity'
      },
      {
        id: 'C',
        text: 'Internal Medicine',
        next: 'clinicianCity'
      },
      {
        id: 'D',
        text: 'Physician Assistant or Nurse Practitioner',
        next: 'clinicianCity'
      },
      {
        id: 'E',
        text: 'Other',
        next: 'clinicianCity'
      }
    ],
    next: 'clinicianCity'
  },
  {
    id: '7',
    questionType: 'input',
    question: `In what city does ... practice.`,
    description: [],
    name: 'clinicianCity',
    required: true,
    type: 'text',
    placeholder: 'Type your answer here...',
    options: [],
    next: 'clinicianState'
  },
  {
    id: '8',
    questionType: 'inputFilter',
    question: 'In what state does ... practice?',
    description: [],
    name: 'clinicianState',
    required: true,
    type: 'text',
    placeholder: 'Type your answer here...',
    options: STATES,
    next: 'appointmentScheduled'
  },
  {
    id: '9',
    questionType: 'multipleChoice',
    question: 'Is your next appointment with your clinician scheduled?',
    description: [
      'We ask this question to ensure aiSLE MGMT is available to you on the date of your visit'
    ],
    name: 'appointmentScheduled',
    required: false,
    type: '',
    placeholder: '',
    options: [
      {
        id: 'Y',
        text: 'Yes',
        next: 'visitDate'
      },
      {
        id: 'N',
        text: 'No',
        next: 'healthInsurancePlan'
      }
    ],
    next: 'visitDate'
  },
  {
    id: 'b',
    questionType: 'inputDate',
    question: 'Date of visit',
    description: [],
    name: 'visitDate',
    required: false,
    type: 'date',
    placeholder: 'Type your answer here...',
    options: [],
    next: 'healthInsurancePlan'
  },
  {
    id: '10',
    questionType: 'multipleChoice',
    question: 'What type of health insurance plan do you have?',
    description: [],
    name: 'healthInsurancePlan',
    required: false,
    type: '',
    placeholder: '',
    options: [
      {
        id: 'A',
        text: 'Medicare',
        next: 'phoneType'
      },
      {
        id: 'B',
        text: 'Medicaid',
        next: 'phoneType'
      },
      {
        id: 'C',
        text: 'Private Insurer',
        next: 'phoneType'
      },
      {
        id: 'D',
        text: 'Not Sure',
        next: 'phoneType'
      },
      {
        id: 'E',
        text: 'Prefer Not to Answer',
        next: 'phoneType'
      }
    ],
    next: 'phoneType'
  },
  {
    id: '11',
    questionType: 'multipleChoice',
    question: 'What kind of phone do you have?',
    description: [],
    name: 'phoneType',
    required: false,
    type: '',
    placeholder: '',
    options: [
      {
        id: 'A',
        text: 'Android',
        next: 'phoneNumber'
      },
      {
        id: 'B',
        text: 'iPhone',
        next: 'phoneNumber'
      }
    ],
    next: 'phoneNumber'
  },
  {
    id: '12',
    questionType: 'inputPhone',
    question: 'Phone number',
    description: [],
    name: 'phoneNumber',
    required: true,
    type: 'text',
    placeholder: 'Type your answer here...',
    options: [],
    next: 'phoneVerificationCell1'
  },
  {
    id: 'a',
    questionType: 'verifyCode',
    question: 'Verify code',
    description: ['Enter your verification code'],
    name: 'verifyCode',
    required: false,
    type: 'text',
    placeholder: 'Type your answer here...',
    options: [],
    next: ''
  }
];
